import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router/dom'
import { createRoot } from 'react-dom/client'

import 'src/index.css'
import 'src/mocks/MockManager'

import { webSessionRecordingService } from 'src/services/WebSessionRecordingService'
import { analyticsService } from 'src/services/AnalyticsService'
import { productAdoptionService } from 'src/services/ProductAdoptionService'
import { UserProvider } from 'src/contexts/UserProvider'
import { QueueProvider } from 'src/contexts/QueueProvider'
import { ConfigurationProvider } from 'src/contexts/ConfigurationContext'
import { rollbarService } from 'src/services/RollbarService'
import { TranscriptErrorProvider } from 'src/contexts/Transcript/TranscriptErrorContext'

import { router } from './routes'

webSessionRecordingService.init()
analyticsService.init()
rollbarService.init()
productAdoptionService.init()

const queryClient = new QueryClient()

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
    <QueryClientProvider client={queryClient}>
        <QueueProvider>
            <ConfigurationProvider>
                <UserProvider>
                    <TranscriptErrorProvider>
                        <RouterProvider router={router} />
                    </TranscriptErrorProvider>
                </UserProvider>
            </ConfigurationProvider>
        </QueueProvider>
    </QueryClientProvider>,
)
